import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/SecurityConfiguration";

export const getSafeTypeList = async () => {
  return axios.get(`${api_base_url}/GetSafeType`).then((res) => {
    return res;
  });
};

export const addSafeType = async (newSafeType) => {
  const { data } = await axios.post(`${api_base_url}/AddSafeType`, {
    ...newSafeType,
  });
  return data;
};

export const deleteSafeType = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateSafeType`, {
    data: ids,
  });
  return data;
};

export const updateSafeType = async (editSafeType) => {
  const { data } = await axios.put(
    `${api_base_url}/EditSafeType`,
    editSafeType
  );
  return data;
};
